
import { RevDivider } from '@ds/components/Divider'
import { RevIllustration } from '@ds/components/Illustration'
import { RevLink } from '@ds/components/Link'
import { openModal } from '@ds/components/ModalBase'
import { IconBadge } from '@ds/icons/IconBadge'
import { IconCalendar } from '@ds/icons/IconCalendar'
import { IconLock } from '@ds/icons/IconLock'
import { IconLockUnlocked } from '@ds/icons/IconLockUnlocked'
import isEmpty from 'lodash/isEmpty'
import { mapGetters } from 'vuex'

import { MODAL_NAMES } from '@config/constants'
import FormattedMessage from '@i18n/components/FormattedMessage'

import translations from './ReassuranceItems.translations'

export default {
  components: {
    IconBadge,
    IconCalendar,
    IconLock,
    IconLockUnlocked,
    RevLink,
    RevDivider,
    RevIllustration,
    FormattedMessage,
  },

  props: {
    carriers: {
      type: Array,
      required: true,
    },
  },

  computed: {
    ...mapGetters({
      coolingOffDays: 'config/coolingOffDays',
    }),
    translations: () => translations,

    itemContainerClassNames() {
      return 'flex flex-row items-center'
    },
    iconClassNames() {
      return 'w-[40px] h-[40px] flex-shrink-0 rounded-sm mr-3 bg-info-ultralight border border-neutral text-info flex items-center justify-center'
    },

    shouldDisplayCarriers() {
      return !isEmpty(this.carriers)
    },

    isSimLocked() {
      return this.carriers.some((carrier) => carrier.isSimLocked)
    },

    blogLink() {
      return {
        type: 'external',
        href: 'https://help.backmarket.com/hc/en-us/articles/360012437860',
      }
    },
  },
  methods: {
    deploySatisfactionModal() {
      openModal(MODAL_NAMES.REASSURANCE.SATISFACTION)
    },
  },
}
